module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.priority === 'primary') { 
    ; __append(" <div class=\"row\"> <div class=\"col-sm-6 col-xs-12 recharge-block\"> <div class=\"form-group\"> <label class=\"label-lg\">Recharge Threshold <small class=\"glyphicon glyphicon-question-sign text-muted\" data-toggle=\"tooltip\" title=\"When your balance drops below this amount, we will automatically charge your primary payment method by the recharge amount to top up your account. We recommend that Bank Account users set a threshold value approximately equal to 5-7 days worth of EasyPost charges, as bank transfers may take that long to process.<br/><br/> Your threshold value must be less than or equal to your recharge amount to avoid repeated threshold recharges.\" data-placement=\"bottom\"></small></label> <div class=\"dropdown\"> <button class=\"btn btn-default btn-block dropdown-toggle\" data-toggle=\"dropdown\"> <span class=\"name\">")
    ; __append(escapeFn( locals.recharge_threshold ))
    ; __append("</span> <span class=\"caret\"></span> </button> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.recharge_threshold_options_dollars).each(function(dollars) { 
    ; __append(" ")
    ;  var cents = dollars * 100 
    ; __append(" <li class=\"")
    ; __append(escapeFn( locals.recharge_threshold_cents == cents ? 'active' : '' ))
    ; __append(" ")
    ; __append(escapeFn( cents > locals.recharge_amount_cents ? 'disabled' : '' ))
    ; __append("\"> <a data-attribute=\"recharge_threshold\" data-amount=\"")
    ; __append(escapeFn( cents ))
    ; __append("\"> $")
    ; __append(escapeFn( dollars ))
    ; __append(" </a> </li> ")
    ;  }); 
    ; __append(" </ul> </div> </div> </div> <div class=\"col-sm-6 col-xs-12 recharge-block\"> <div class=\"form-group\"> <label class=\"label-lg\">Recharge Amount</label> <div class=\"dropdown\"> <button class=\"btn btn-default btn-block dropdown-toggle\" data-toggle=\"dropdown\"> <span class=\"name\">")
    ; __append(escapeFn( locals.recharge_amount ))
    ; __append("</span> <span class=\"caret\"></span> </button> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.recharge_amount_options_dollars).each(function(dollars) { 
    ; __append(" ")
    ;  var cents = dollars * 100 
    ; __append(" <li class=\"")
    ; __append(escapeFn( locals.recharge_amount_cents == cents ? 'active' : '' ))
    ; __append(" ")
    ; __append(escapeFn( cents < locals.recharge_threshold_cents ? 'disabled' : '' ))
    ; __append("\"> <a data-attribute=\"recharge_amount\" data-amount=\"")
    ; __append(escapeFn( cents ))
    ; __append("\"> $")
    ; __append(escapeFn( dollars ))
    ; __append(" </a> </li> ")
    ;  }); 
    ; __append(" </ul> </div> </div> </div> </div> ")
    ;  } else { 
    ; __append(" <div class=\"row\"> <div class=\"col-sm-6 col-sm-offset-6 col-xs-12 recharge-block\"> <div class=\"form-group\"> <label class=\"label-lg\">Recharge Amount</label> <div class=\"dropdown\"> <button class=\"btn btn-default btn-block dropdown-toggle\" data-toggle=\"dropdown\"> <span class=\"name\">")
    ; __append(escapeFn( locals.secondary_recharge_amount ))
    ; __append("</span> <span class=\"caret\"></span> </button> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.secondary_recharge_amount_options_dollars).each(function(dollars) { 
    ; __append(" ")
    ;  var cents = dollars * 100 
    ; __append(" <li class=\"")
    ; __append(escapeFn( locals.secondary_recharge_amount_cents == cents ? 'active' : '' ))
    ; __append("\"> <a data-attribute=\"secondary_recharge_amount\" data-amount=\"")
    ; __append(escapeFn( cents ))
    ; __append("\"> $")
    ; __append(escapeFn( dollars ))
    ; __append(" </a> </li> ")
    ;  }); 
    ; __append(" </ul> </div> </div> </div> </div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/recharge_settings.ejs
// module id = 905
// module chunks = 1